import dayjs from 'dayjs';
import { Options } from 'highcharts';
import _ from 'underscore';

const toUnix = (date: string) => dayjs(date.substring(0, 10)).local().valueOf();

const mapDates = (dates: string[], value: number) => {
  return _.chain(dates)
    .map((date) => ({ x: toUnix(date), y: value }))
    .value();
};

const renderSymbols = (date: string) => {
  return {
    x: dayjs(date).utc().valueOf(),
    y: 0,
  };
};

/**
 * Sorts the given dates in ascending order and removes the time part from them. Need it to match the dates in the inventory array.
 * @param data The array of objects with date and value properties.
 * @returns A new array of objects with date and value properties, sorted by date.
 */
const reformatDates = (data: { date: string; value: number }[]): { date: string; value: number }[] => {
  return [...data]
    .sort((a, b) => toUnix(a.date) - toUnix(b.date)) // Sort dates in ascending order
    .map(({ date, value }) => ({ date: date.split('T')[0], value })); // Remove time from date
};

const commonStyle = {
  fontFamily: 'DM Sans, Arial',
  color: '#012231', // dark blue, unable to use theme context
  fontSize: '12px',
};

const options: Options = {
  time: {
    useUTC: false,
  },
  tooltip: {
    headerFormat: '<b>{point.key}</b><br/>',
    pointFormat: '<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.y} kg</b><br/>',
    style: {
      fontSize: '13px',
    },
  },
  chart: {
    type: 'column',
    borderRadius: 10,
    style: {
      ...commonStyle,
    },
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: true,
    symbolHeight: 12,
    symbolWidth: 12,
    symbolRadius: 8,
    itemStyle: {
      fontSize: '12',
    },
  },
  plotOptions: {
    line: {
      marker: {
        symbol: 'circle',
        radius: 0,
      },
    },
    column: {
      borderRadius: 20,
    },
  },
  title: {
    text: '.',
    style: {
      fontFamily: 'DM Sans, Arial',
      fill: 'white',
      color: 'white',
    },
  },
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      day: '%e %b',
    },
    labels: {
      style: {
        ...commonStyle,
      },
    },
  },
  yAxis: {
    tickInterval: 40000,
    title: {
      text: '',
      style: {
        ...commonStyle,
        fontSize: '14px',
        textTransform: 'none',
      },
    },
    labels: {
      style: {
        ...commonStyle,
      },
    },
    stackLabels: {
      enabled: true,
      style: {
        ...commonStyle,
        fontWeight: '500',
        fontSize: '16px',
      },
    },
  },
};

export { options, reformatDates, renderSymbols, mapDates };
